import React, { useEffect } from 'react'
import { css } from '@emotion/react'
import Services from 'gatsby-theme-marketplace-base/src/components/Sidebar/Services'
import { URLS, FILTERS } from 'gatsby-theme-marketplace-base/src/constants'
import { useEnhancedList } from 'gatsby-theme-marketplace-base/src/context/EnhancedList'
import { getLocalStorageValue } from 'gatsby-theme-marketplace-base/src/utils/browser/storage'
import FeaturedCategories from 'gatsby-theme-marketplace-base/src/components/Sidebar/FeaturedCategories'
import { FEATURED_EXPERT_CATEGORIES } from 'gatsby-theme-marketplace-base/src/constants'
import useHydrationContext from 'gatsby-theme-marketplace-base/src/hooks/useHydrationContext'

const expertsCss = css`
  .collapse__label {
    padding: 0 26px;
    align-items: center;

    > a {
      margin-bottom: 5px;

      > svg {
        margin-top: 0;
        margin-right: 12px;
      }
    }
  }

  .collapse__content {
    margin-top: 10px;
    padding-left: 22px;

    div > a {
      margin: 4px 0;
    }
  }
`

const featuredCategoriesCss = css`
  margin-bottom: 14px;

  > ul > a {
    margin: 10px 0 10px -5px !important;

    > svg {
      margin-top: 0 !important;
    }
  }
`

export default (props) => {
  const { filtersOptions } = useEnhancedList()
  const hydrated = useHydrationContext()

  const serviceOptionsContext = filtersOptions?.[FILTERS.SERVICE.ID]
  const serviceOptionsStorage = getLocalStorageValue(FILTERS.SERVICE.ID)

  const serviceOptions =
    serviceOptionsContext && serviceOptionsContext.length
      ? serviceOptionsContext
      : serviceOptionsStorage

  useEffect(() => {
    if (serviceOptions?.length) {
      localStorage.setItem(FILTERS.SERVICE.ID, JSON.stringify(serviceOptions))
    }
  }, [serviceOptions])

  return (
    <Services
      label="Partners"
      isOpenOnInit={false}
      options={hydrated ? serviceOptions : []}
      labelIcon={URLS.EXPERTS.LABEL}
      css={expertsCss}
      links={
        <div css={featuredCategoriesCss}>
          <FeaturedCategories categories={FEATURED_EXPERT_CATEGORIES} />
        </div>
      }
      {...props}
    />
  )
}
